(() => {
  const activateTab = (options) => {
    const {
      tabs, tabpanels, index,
    } = options;

    tabs.forEach((tab, elemIndex) => {
      if (!tab.hasAttribute('role')) {
        tab.setAttribute('role', 'tab');
      }

      if (elemIndex === index) {
        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');
      } else {
        tab.removeAttribute('aria-selected');
        tab.setAttribute('tabindex', '-1');
      }
    });

    tabpanels.forEach((tabpanel, elemIndex) => {
      if (!tabpanel.hasAttribute('role')) {
        tabpanel.setAttribute('role', 'tabpanel');
      }

      if (elemIndex === index) {
        window.swinger.visibility.show(tabpanel);
        tabpanel.setAttribute('tabindex', '-1');
      } else {
        window.swinger.visibility.hide(tabpanel);
        tabpanel.removeAttribute('tabindex');
      }
    });
  };

  window.swinger.eventHub.register('click keydown', '.swinger-tabs__tablist-link', (e) => {
    if (e.type === 'keydown') {
      switch (e.key) {
        default:
          return;

        case 'Up':
        case 'ArrowUp':
        case 'Right':
        case 'ArrowRight':
        case 'Down':
        case 'ArrowDown':
        case 'Left':
        case 'ArrowLeft':
          break;
      }
    }

    const tab = window.swinger.eventHub.getTarget(e);
    const tabList = tab.closest('.swinger-tabs__tablist');
    const tabs = window.swinger.$('.swinger-tabs__tablist-link', tabList);
    const index = tabs.indexOf(tab);
    const container = tab.closest('.swinger-tabs');
    const tabpanels = window.swinger.$(':scope > .swinger-tabs__tabpanel', container);

    if (e.type === 'click') {
      window.swinger.transition.execute(() => {
        activateTab({
          tabs,
          tabpanels,
          index,
        });

        const focusableElementsSelector = window.swinger.focusableElements.join(',');
        const focusableElements = window.swinger.$(focusableElementsSelector, tabpanels[index]);

        if (focusableElements.length) {
          focusableElements[0].focus({ preventScroll: true });
        }
      });

      e.preventDefault();

      return;
    }

    switch (e.key) {
      default:
        return;

      case 'Left':
      case 'ArrowLeft':
        if (index > 0) {
          window.swinger.transition.execute(() => {
            activateTab({
              tabs,
              tabpanels,
              index: index - 1,
            });

            tabs[index - 1].focus({ preventScroll: true });
          });
        }
        break;

      case 'Right':
      case 'ArrowRight':
        if (index < (tabs.length - 1)) {
          window.swinger.transition.execute(() => {
            activateTab({
              tabs,
              tabpanels,
              index: index + 1,
            });

            tabs[index + 1].focus({ preventScroll: true });
          });
        }
        break;

      case 'Up':
      case 'ArrowUp':
        break;

      case 'Down':
      case 'ArrowDown':
        tabpanels[index].focus({ preventScroll: true });
        break;
    }
  });

  const activateTabWithElement = (elem) => {
    const tabpanel = elem.closest('.swinger-tabs__tabpanel');
    const container = elem.closest('.swinger-tabs');
    const tabs = window.swinger.$('.swinger-tabs__tablist-link', container);
    const tabpanels = window.swinger.$(':scope > .swinger-tabs__tabpanel', container);
    const index = tabpanels.indexOf(tabpanel);

    activateTab({
      tabs,
      tabpanels,
      index,
    });
  };

  window.swinger.eventHub.register('focus', '.swinger-tabs__tabpanel > *', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    activateTabWithElement(elem);
  });

  window.swinger.observer.initialize('.swinger-tabs :target', activateTabWithElement, false);

  window.swinger.observer.initialize('.swinger-tabs', (elem) => {
    const tabs = window.swinger.$(':scope > .swinger-tabs__tablist .swinger-tabs__tablist-link', elem);
    const tabpanels = window.swinger.$(':scope > .swinger-tabs__tabpanel', elem);
    let activeElement = document.activeElement;
    try {
      activeElement = document.querySelector(window.location.hash);
    } catch (e) {
      // noop
    }
    const index = Math.max(0, tabpanels.findIndex((tabpanel) => tabpanel.contains(activeElement)));

    activateTab({
      tabs,
      tabpanels,
      index,
    });
  }, false);
})();
